<ng-container *transloco="let t; read: 'user'">
  <div class="fix-action-row modal-body">
    <div class="flex justify-between border-b">
      <h1 class="text-[25px] font-bold">
        {{ t('manageEnrollment.batchSpedExitDate.title') }}
      </h1>
      <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
    </div>

    <div mat-dialog-content>
      <div class="mt-4"> {{ t('manageEnrollment.batchSpedExitDate.eligibilityNote') }} <br>
      {{ t('manageEnrollment.batchSpedExitDate.onlyFollowingUpdated') }} </div>
      <div class="mt-2">
        <ul>
          @for (student of students; track student) {
            <li>
              <mat-checkbox [(ngModel)]="student.isChecked">
                <!-- Child name is server-supplied. -->
                <strong>{{ student.firstName }} {{ student.lastName }}</strong> {{ t('manageEnrollment.batchSpedExitDate.spedEntryDateSuffix', {
                  date: student.spedEntryDate
                    ? (student.spedEntryDate | localizedDate: 'MM/dd/yyyy')
                    : t('manageEnrollment.batchSpedExitDate.notAvailable')
                }) }}
              </mat-checkbox>
            </li>
          }
        </ul>
      </div>
      <form [formGroup]="spedExitDateForm">
        <div class="relative">
          <div class="mt-2">
            <drdp-date-picker [label]="t('manageEnrollment.spedExitDate.exitDateLabel')" [isRequired]="true" [minDate]="minSpedEntryDate"
              (emitDate)="handleDate($event)">
            </drdp-date-picker>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div mat-dialog-actions class="flex justify-end">
    <drdp-btn color="cancel" mat-button mat-dialog-close>{{ t('manageEnrollment.myClasses.actions.cancel') }}</drdp-btn>
    <drdp-btn class="ml-3" mat-button [disabled]="spedExitDateForm.invalid || isProcessing" cdkFocusInitial
      (click)="onSubmit()">{{ t('manageEnrollment.myClasses.actions.save') }}
    </drdp-btn>
  </div>
</ng-container>
